export const MembershipCardStatus = Object.freeze({
  // The following enum values map to values from the POST Create MembershipCard API response
  ACTIVE: 'Active',
  INACTIVE: 'Lost/Stolen',
  QUEUED: 'Queued',
});

export default MembershipCardStatus;
